exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/less-loader/dist/cjs.js?{modifyVars:{"@primary-color":"#621816"}}!./~/antd/lib/icon/style/index.less
// module id = 949
// module chunks = 0